import { render, staticRenderFns } from "./ServiceOrder.vue?vue&type=template&id=1305c69e&scoped=true"
import script from "./ServiceOrder.vue?vue&type=script&lang=ts"
export * from "./ServiceOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305c69e",
  null
  
)

export default component.exports